import { render, staticRenderFns } from "./iban.vue?vue&type=template&id=e06363b6&lang=pug&"
import script from "./iban.vue?vue&type=script&lang=js&"
export * from "./iban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports